export const PIN_STATUS_NON_ATTIVO = "pin.non_attivo"
export const PIN_STATUS_ATTIVO = "pin.attivo"

export const ORDINE_COMPLETATO = "complete"
export const ORDINE_RIMBORSATO = "refund"